import styled from 'styled-components';
import media from 'styled-media-query';

export const FooterWrapper = styled.footer`
  border-top: 1px solid var(--gray-light);
  background-color: var(--gray-extra-light);
  color: var(--gray-light);
  margin-top: auto;
`;

export const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 1vh 5vh;
  font-size: 80%;
  
  ${media.greaterThan('medium')`
    padding: 1vh 10vh;
  `}
`;
